import React from "react";
var __jsx = React.createElement;
import FormKeep from './FormKeep';
function FormKeepAdapter(_ref) {
  var entry = _ref.entry,
    data = _ref.data;
  return __jsx(FormKeep, {
    reCaptchaKey: data.siteData.reCaptchaKey,
    formkeepTest: entry.formKeepCode,
    bookFormData: entry
  });
}
export default FormKeepAdapter;